export const IMAGE_BASE_URL = "https://managemyshaadib.s3.ap-south-1.amazonaws.com/";

/**
 * Formats image URL for display.
 * If path is relative (e.g. "/f2f843b5-17da-4665-82ea-fe503051a0ab.jpg"),
 * appends base URL ("https://api.managemyshaadi.com").
 * Returns blob, data, and absolute HTTP/HTTPS URLs as-is.
 */

export const getImageUrl = (path) => {
  if (!path) return "";
  if (
    path.startsWith("blob:") ||
    path.startsWith("http://") ||
    path.startsWith("https://") ||
    path.startsWith("data:")
  ) {
    return path;
  }
  const cleanBase = IMAGE_BASE_URL.replace(/\/+$/, "");
  const cleanPath = path.startsWith("/") ? path : `/${path}`;
  return `${cleanBase}${cleanPath}`;
};

/**
 * Extracts relative image key or path from backend upload response.
 * Handles responses returning { key: "/..." } or { data: { key: "/..." } }.
 */
export const extractImageUrl = (res) => {
  if (!res) return "";
  const data = res.data;
  if (typeof data === "string") return data;
  if (data?.key) return data.key;
  if (data?.url) return data.url;
  if (data?.image) return data.image;
  if (data?.location) return data.location;
  if (data?.path) return data.path;
  if (data?.data) {
    if (typeof data.data === "string") return data.data;
    if (data.data.key) return data.data.key;
    if (data.data.url) return data.data.url;
    if (data.data.image) return data.data.image;
    if (data.data.location) return data.data.location;
    if (data.data.path) return data.data.path;
  }
  return "";
};
